import { useState, useCallback } from 'react';

export const useGroupTitleManagement = (getGroupTitle, updateGroupTitle) => {
  const [editingGroupTitle, setEditingGroupTitle] = useState({});

  const getCurrentGroupTitle = useCallback((groupName) => {
    if (editingGroupTitle[groupName] !== undefined) {
      return editingGroupTitle[groupName];
    }
    return getGroupTitle(groupName) || `Gruppo: ${groupName}`;
  }, [editingGroupTitle, getGroupTitle]);

  const handleGroupTitleChange = useCallback((groupName, value) => {
    setEditingGroupTitle(prev => ({
      ...prev,
      [groupName]: value
    }));
  }, []);

  const handleGroupTitleBlur = useCallback((groupName) => {
    const newTitle = editingGroupTitle[groupName];
    if (newTitle !== undefined) {
      updateGroupTitle(groupName, newTitle);
      setEditingGroupTitle(prev => {
        const { [groupName]: removed, ...rest } = prev;
        return rest;
      });
    }
  }, [editingGroupTitle, updateGroupTitle]);

  const handleGroupTitleKeyDown = useCallback((e, groupName) => {
    if (e.key === 'Enter') {
      e.target.blur();
    }
  }, []);

  return {
    getCurrentGroupTitle,
    handleGroupTitleChange,
    handleGroupTitleBlur,
    handleGroupTitleKeyDown,
    editingGroupTitle,
    setEditingGroupTitle,
  };
};
